import React from "react"
import { Form, Input } from "antd"

import { WidgetCard } from "@src/pages/widgetModify/ui/WidgetCard"

export const WidgetCallbackUrls = () => {
  return (
    <WidgetCard title="Callback URLs">
      <Form.Item
        id="GENERATED_ID_WIDGETCALLBACKURLS_TSX_FORM.ITEM_VOID_1"
        label="Callback URL"
        name="callback_url"
        rules={[{ type: "url" }]}
      >
        <Input placeholder="Callback URL" />
      </Form.Item>
    </WidgetCard>
  )
}
